import ValidatedSelect from '../../common/forms/ValidatedSelect';
import { useJobQuery } from './common/useJobQuery';

export const Jobs = () => {
    const { data, isLoading } = useJobQuery();

    return (
        <ValidatedSelect
            id="jobId"
            name="jobId"
            options={data}
            label="Number"
            isLoading={isLoading}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            menuPlacement="auto"
        />
    );
};